export default __webpack_public_path__ + "static/media/Blue-bg.10c2369e.jpg";